<div class="container-fluid">

  <h4 id="upper">Projets</h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>
            <!--  -->
            <a href="javascript:void(0);" class="btn btn-success mb-2" id="gras" (click)="openModal()">
              <i class="mdi mdi-plus me-2"></i> Ajouter un Projet
            </a>
          </div>
          <div class="col-md-12 d-flex justify-content-end">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <label class="d-inline-flex align-items-center">
                Rechercher:
                <input type="text" name="searchTerm" [(ngModel)]="searchTerm" (keyup)="filterProjet()" class="form-control form-control-sm ms-2" aria-controls="tickets-table">
              </label>
            </div>
          </div>
        
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light  rwd-table">
                <tr>
                  <th style="width: 20px;">
                  </th>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Sigle</th>
                  <th>Poids</th>
                  <th style="white-space: nowrap;">Objectif global</th>
                  <th>Résultat</th>
                  <!-- <th>Responsable</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of filteredProjetData ; let index = index">
                  <td>
                  </td>
                  <td>{{item?.code}}</td>
                  <td>{{item?.libelle}}</td>
                  <td>{{item?.sigle}}</td>
                  <td>{{item?.poids  }}</td>
                  <td>{{item?.objectif_global }}</td>
                  <!-- <td>{{item?.resultat_projet | limitTo:10}}</td> -->
                  <td>
                    <a (click)="DetailModal(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover
                      title="Indicateurs">
                      <i class="mdi mdi-link font-size-18"></i>
                    </a>
                    <a (click)="EditModal(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover
                      title="Modifier">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a (click)="confirmDeletion(item)" href="javascript:void(0);" class="text-danger" v-b-tooltip.hover
                      title="Retirer">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>

                <tr *ngIf="projetData.length === 0 && isLoading === false">
                  <td colspan="8">
                    <div class="row">
                      <div class="text-center">
                        <h5 id="graycolor">Aucune donnée trouvée</h5>
                      </div>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>

    </div>

  </div>
</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>